import store from "./store";
const io = require("socket.io-client");
const directMutations = false;
// For production behind a reverse proxy on the same domain, leave this undefined and use a relative socket path.
// For separate domains, set VUE_APP_SOCKET_URL (e.g., https://api.example.com).
const url = process.env.VUE_APP_SOCKET_URL || "localhost:3000";
const ioOptions = {
	path: "/socket-server",
	transports: ["websocket"],
	withCredentials: true,
	autoConnect: false,
};

// Exports
export const socket = io(url, ioOptions);
export function establishConnection() {
	return new Promise((res, rej) => {
		if (socket.connected) res();

		socket.open() && console.log("Establishing connection...");
		socket.on("connect", () => {
			clearTimeout(checkConnection);
			res();
		});

		const checkConnection = setTimeout(() => {
			console.log("Timeout called!");
			if (!socket.connected) {
				socket.removeAllListeners();
				socket.close();
				rej();
			}
		}, 2000);
	});
}

// Event listeners
if (socket) {
	socket.on("connect", () => {
		store.commit("USER_SET_CONNECTED");
		store.commit("USER_SET_ID", socket.id);
	});
	socket.on("connect_error", err => {
		console.log("CONNECTION FAILED", err);
	});

	// Joining a game
	socket.on("join-success", (aGame, aPlayer) => {
		// console.log("THIS IS A GAME", aGame);
		if (directMutations) {
			store.commit("SET_JOINED_GAME");
			store.commit("SET_GAME_ROOM", aGame.id);
			store.commit("SET_GAME_SETTINGS", aGame.settings);
			store.commit("SET_ME", aPlayer.pos);
			store.commit("USER_SET_NAME", aPlayer.name);
			store.commit("ADD_LOG_MESSAGE", "Joined successfully!");
		} else {
			store.dispatch("joinedGame", { aGame, aPlayer });
		}
	});
	socket.on("join-error", anError => {
		store.dispatch("addError", anError);
	});
	socket.on("reconnect-success", (aGame, aPlayer) => {
		store.dispatch("joinedGame", { aGame, aPlayer });
		store.dispatch("playStartGame", aGame.state);
	});
	socket.on("reconnect-error", anError => {
		console.log(anError);
		store.dispatch("addError", anError);
		store.dispatch("clearLocalData");
	});
	socket.on("set-local-storage-id", aSocketId => {
		store.dispatch("setLocalStorageId", aSocketId);
	});
	socket.on("set-local-storage-room-code", aRoomCode => {
		store.dispatch("setLocalStorageRoomCode", aRoomCode);
	});

	// Requesting state
	socket.on("game-object", aGameObject => {
		store.commit("SET_GAME_OBJECT", aGameObject);
	});
	// socket.on("game-players", playersArr => {
	// 	store.commit("SET_PLAYERS", playersArr);
	// });

	// Join, leave, disconnect, reconnect
	socket.on("player-joined", aPlayer => {
		store.dispatch("playerJoined", aPlayer);
	});
	socket.on("player-left", aPlayerPos => {
		store.dispatch("playerLeft", aPlayerPos);
	});
	socket.on("player-reconnected", aPlayerPos => {
		store.dispatch("playerReconnected", aPlayerPos);
	});
	socket.on("player-disconnected", aPlayerPos => {
		store.dispatch("playerDisconnected", aPlayerPos);
	});

	// During play
	socket.on("game-started", aGameState => {
		store.dispatch("playStartGame", aGameState);
	});
	socket.on("pass-turn", () => {
		directMutations
			? store.commit("PLAY_PASS_TURN") // Direct mutation
			: store.dispatch("playPassTurn"); // Call action first
	});
	socket.on("add-point", toTeam => {
		directMutations
			? store.commit("PLAY_ADD_POINT", toTeam) // Direct mutation
			: store.dispatch("playAddPoint", toTeam); // Call action first
	});
	socket.on("remove-value", aValue => {
		directMutations
			? store.commit("PLAY_REMOVE_VALUE", aValue) // Direct mutation
			: store.dispatch("playRemoveValue", aValue); // Call action first
	});
	socket.on("announce-winner", () => {
		directMutations
			? store.commit("PLAY_ANNOUNCE_WINNER") // Direct mutation
			: store.dispatch("playAnnounceWinner"); // Call action first
	});
	socket.on("refresh-state", aGameState => {
		store.dispatch("playRefreshState", aGameState);
	});

	// Handling errors
	socket.on("play-error", anError => {
		store.dispatch("addError", anError);
	});

	// Development
	socket.on("dev-add-error", anError => {
		store.dispatch("addError", anError);
	});

	socket.on("disconnect", aReason => {
		console.log("REASON FOR DISCONNECTING", aReason);
		store.commit("USER_SET_DISCONNECTED");
		store.commit("SET_LEAVE_GAME");
	});
}

// CLIENT JOINING
// join-success
// join-error
// reconnect-success
// reconnect-error
// set-local-storage-id
// set-local-storage-room-code
// send-new-game-code

// game-players

// BROADCASTING
// player-joined
// player-left
// player-reconnected
// player-disconnected

// kick-out

// GAMEPLAY
// game-started
// play-error
// pass-turn
// add-point
// remove-value
// announce-winner

// DEV
// dev-add-error
// test-response
